<template>
  <v-input :value="value" :rules="rules">
    <label style="position:absolute;top:0;left:0;">{{ label }}</label>
    <div v-if="innerValue" style="margin-top:22px;">
      <v-container no-gutters pa-0>
        <v-row no-gutters>
          <v-col>
            <v-menu
              ref="popup"
              bottom
              origin="center center"
              transition="scale-transition"
              v-model="showTrans"
              :close-on-content-click="false"
            >
              <template v-slot:activator="{}">
                <quill-editor
                  :ref="quillRef(language.language)"
                  :value="
                    innerValue[
                      $helpers.correctCase(language.language, innerValue)
                    ]
                  "
                  @input="onLanguageInput($event, language.language)"
                  :options="editorOption"
                />
              </template>
              <v-list>
                <v-list-item
                  v-for="(lang, index) of languages.filter(
                    (l) => l.language !== language.language
                  )"
                  :key="index"
                >
                  {{ lang.language.toUpperCase() }}
                  <quill-editor
                    v-if="showTrans"
                    v-on:keydown.tab="
                      $refs.button.$el.focus();
                      showTrans = false;
                    "
                    :ref="quillRef(index)"
                    :value="
                      innerValue[
                        $helpers.correctCase(lang.language, innerValue)
                      ]
                    "
                    @input="onLanguageInput($event, lang.language)"
                    :options="editorOption"
                    @ready="onReady($event, index)"
                  />
                </v-list-item>
              </v-list>
            </v-menu>
          </v-col>

          <v-col
            cols="auto"
            v-if="languages.length > 1"
            style="margin-top:20px;margin-left:3px"
          >
            <v-btn
              ref="button"
              @click="openAndFocus()"
              depressed
              small
              color="success"
            >
              <v-icon>language</v-icon>
            </v-btn>
          </v-col>
        </v-row>
      </v-container>
      <v-dialog scrollable v-model="linkDialog" persistent max-width="500">
        <v-card v-if="link !== null && link !== undefined">
          <v-card-title class="headline">
            {{ $t("components.transtexteditor.link") }}
          </v-card-title>
          <v-card-text>
            <v-container fluid fill-height>
              <v-flex md12>
                <v-form ref="linkForm" v-model="valid">
                  <v-checkbox
                    :label="$t('components.transtexteditor.is_button')"
                    v-model="link.isButton"
                  ></v-checkbox>
                  <no-autocomplete-textfield
                    :label="$t('components.transtexteditor.url')"
                    v-model="link.url"
                  ></no-autocomplete-textfield>
                </v-form>
              </v-flex>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-btn @click="cancel" text>
              {{ $t("globals.cancel") }}
            </v-btn>
            <v-btn color="primary" @click="saveLink" :disabled="!valid">
              {{ $t("globals.save") }}
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </div>
  </v-input>
</template>

<script>
import { isObject } from "vuetify/lib/util/helpers";
import { mapGetters } from "vuex";
export default {
  props: ["value", "rules", "label"],
  data() {
    return {
      showTrans: false,
      innerValue: null,
      quill: null,
      linkDialog: false,
      valid: false,
      link: null,
      editorData: "<p>Rich-text editor content.</p>",
      editorOption: {
        modules: {
          // toolbar: {
          //   handlers: {
          //     // handlers object will be merged with default handlers object
          //     link: function(value) {
          //       console.log("link: ", value);
          //       if (value) {
          //         var href = prompt("Enter the URL");
          //         this.quill.format("link", href);
          //       } else {
          //         this.quill.format("link", false);
          //       }
          //     },
          //   },
          // },
          toolbar: [
            ["bold", "italic", "underline", "strike"], // toggled buttons
            ["blockquote", "code-block"],

            [{ header: 1 }, { header: 2 }], // custom button values
            [{ list: "ordered" }, { list: "bullet" }],
            [{ script: "sub" }, { script: "super" }], // superscript/subscript
            [{ indent: "-1" }, { indent: "+1" }], // outdent/indent
            [{ direction: "rtl" }], // text direction

            [{ size: ["small", false, "large", "huge"] }], // custom dropdown
            [{ header: [1, 2, 3, 4, 5, 6, false] }],

            [{ color: [] }, { background: [] }], // dropdown with defaults from theme
            [{ font: [] }],
            [{ align: [] }],

            ["clean"], // remove formatting button
            ["link", "image", "video"],
            ["theme-btn"],
          ],
        },
      },
      btnListeners: [],
    };
  },
  computed: {
    ...mapGetters("common", ["language", "languages"]),
  },
  watch: {
    dialog: {
      handler(v) {
        if (!v) this.showTrans = false;
      },
    },
    value: {
      handler(v) {
        if (v !== null && v !== undefined) {
          this.innerValue = JSON.parse(JSON.stringify(v));
        } else {
          this.innerValue = {};
        }
      },
    },
    // innerValue: {
    //   handler(v) {
    //     console.log(v);
    //   },
    // },
  },
  mounted() {
    // console.log("mounted", this.value)
    if (this.value !== null && this.value !== undefined) {
      this.innerValue = JSON.parse(JSON.stringify(this.value));
    } else {
      this.innerValue = {};
    }
    this.$nextTick(() => {
      for (let lang of this.languages) {
        let quillref = this.$refs[this.quillRef(lang.language)];

        if (Array.isArray(quillref)) {
          quillref = quillref[0];
        }

        //console.log(quillref);
        if (quillref !== null && quillref !== undefined) {
          var themeButton = quillref.$el.querySelector(".ql-theme-btn");
          const listener = function() {
            //console.log("function called");
            var range = quillref.quill.getSelection();
            if (range) {
              //console.log("range is valid");
              quillref.quill.formatText(range, "theme-btn");
            } else {
              //console.log("it it invalid");
            }
          };
          themeButton.addEventListener("click", listener);
          this.btnListeners.push({ themeButton, listener });
        }
      }
    });
  },
  beforeDestroy() {
    this.btnListeners.forEach(({ btn, listener }) => {
      btn.removeEventListener("click", listener);
    });
  },
  methods: {
    quillRef(index) {
      const name = "quillEditor" + index.toString();
      //console.log(name);
      return name;
    },
    customLinkHandler(value, quillRefIndex) {
      //console.log("link: ", value, quillRefIndex);
      if (value) {
        this.quill = this.$refs[this.quillRef(quillRefIndex)][0].quill;
        this.link = {};
        this.linkDialog = true;
      } else {
        this.quill.format("link", false);
        this.quill = null;
        this.link = null;
      }
    },
    saveLink() {
      if (this.link.isButton) {
        const range = this.quill.getSelection({ focus: true });
        // console.log("clicked: ", range);
        if (range) {
          this.quill.formatText(range.index, range.length, "theme-btn");
          // const text = this.quill.getText(range.index, range.length);

          // let ThemeBtn = new Parchment.Attributor.Class("theme-btn", "theme-btn");
          // Parchment.register(ThemeBtn);

          // let btn = document.createElement("div");
          // btn.innerHTML = '<a href="'+this.link.url+'">'+text+'</a>';
          // ThemeBtn.add(btn, "theme-btn");
          // console.log(btn.outerHTML); // Will print <div class="blot-align-right"></div>

          // // const btn = '<div class="theme-btn">' + text + '</div>';

          // this.quill.deleteText(range.index, range.length);

          // this.quill.insertEmbed(
          //   range.index,
          //   btn
          // );
          // quill.setSelection(range.index, btn.length)
          // this.quill.format("class", "theme-btn")

          // this.quill.formatText(range.index, range.length, {
          //   class: "theme-btn",
          //   link: this.link.url,
          // });

          // var quill = new Quill('#editor', {
          //   theme: 'snow',
          //   modules: {
          //     toolbar: [
          //       ['theme-btn']
          //     ]
          //   }
          // });
          this.quill.format("theme-btn");
        }
      } else {
        this.quill.format("link", this.link.url);
      }
      this.linkDialog = false;
      //console.log(this.quill.getContents());
    },
    onLanguageInput(v, lang) {
      let val = {};
      if (isObject(this.innerValue)) {
        val = JSON.parse(JSON.stringify(this.innerValue));
      }
      val[this.$helpers.correctCase(lang, this.innerValue)] = v;
      this.$nextTick(() => {
        // this.innerValue = val;
        this.$emit("update:value", val);
      });
    },
    openAndFocus() {
      this.showTrans = !this.showTrans;
      // const t = setTimeout(() => {
      //   console.log(this.$refs[this.quillRef(0)])
      //   this.$refs[this.quillRef(0)][0].$el.focus();
      //   clearTimeout(t);
      // }, 100);
    },
    onReady(editor, index) {
      // console.log(index, editor)
      if (index === 0) {
        editor.focus();
      }
    },
  },
};
</script>
